<template>
    <div>
        <div class="others-setting-page">
            <!-- 其他设置页面 -->
            <div class="others-setting-title">{{ $t('Setting.common_setting') }}</div>
            <el-form
                ref="form"
                label-width="320px"
                label-position="left">
                <template v-for="(item, index) in form">
                    <el-form-item :key="index">
                        <span slot="label" class="flex">
                            {{ item.name }}
                            <el-tooltip
                                v-if="item.extra"
                                effect="dark" style="margin: 0 4px;"
                                placement="bottom">
                                <div slot="content" v-html="item.extra"></div>
                                <div
                                    class="iconfont icon-fitness-help cursor-pointer"
                                ></div>
                            </el-tooltip>
                            ：
                        </span>
                        <div v-if="item.type === 'BOOLEAN' || item.type === 'OPTION'">
                            <el-radio
                                v-for="(optional, optionalIndex) in item.optionalValue"
                                :key="optionalIndex"
                                v-model="post.settings[index].value"
                                :label="optional.value"
                            >{{ optional.name }}</el-radio>
                        </div>
                        <div v-if="item.type === 'NUMBER'">
                            <el-input
                                v-model.number="post.settings[index].value"
                                type="number"
                                :min="1"
                                style="width: 110px;" />
                            <span> {{ item.unit }}</span>
                        </div>
                    </el-form-item>
                </template>
            </el-form>
        </div>
        <div class="mt-10 others-setting-btn">
            <el-button @click="submit()" type="primary">{{ $t('Common.save') }}</el-button>
        </div>
    </div>
</template>

<script>
import { Tabs, TabPane, Radio } from 'element-ui';

export default {
    components: {
        ElRadio: Radio,
    },
    data() {
        return {
            form: {},
            settings: [],
            post: {
                settings: [],
            },
        };
    },
    created() {
        this.fetchData();
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        fetchData() {
            API.get(`other-setting`).then(res => {
                this.form = res;
                this.post.settings = res.map(el => {
                    const item = {
                        code: el.code,
                        value: el.type === 'NUMBER' ? Number(el.value) : el.value,
                    };
                    return item;
                });
            });
        },
        submit() {
            API.put(`other-setting`, this.post).then(res => {
                $ele.$message.success(this.$t('Message.success'));
                this.fetchData();
            });
        },
    },
};

</script>
<style lang="scss">
.others-setting-page {
    padding: 20px;
    border: 1px solid #e6e6e6;
}
.others-setting-title {
    font-size: 13px;
    margin-bottom: 15px;
}
.others-setting-btn {
    margin-left: 340px;
}
</style>
